import React from 'react';
import { useDispatch } from 'react-redux';
import { KTCard } from '../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../_metronic/helpers/components/KTCardBody';
import { storeEbbeModalCallback } from '../../redux/reducers/authSlice';
import QrEtiket from './QrEtiket';
import { qrYazdir } from './qrYazdir';
import { noktaEtiketleri, NoktaQrBilgisi, QR_RENKLERI } from './noktaEtiketleri';

interface Props {
    nokta: NoktaQrBilgisi
    /** Onaylanınca çağrılır: ambalaj = true yalnız Ambalaj QR'ını, false noktanın bütün QR'larını yeniler. */
    onYenile: (ambalaj: boolean) => void
}

/**
 * QR Noktası kaydında QR bölümü (QR Mesai Faz 2, 18.10.2026).
 * Depo: Lojistik (mavi) ve Ambalaj (turuncu) QR'ları yan yana; "QR Yazdır" ikisini birlikte basar.
 * Ofis: tek QR (iş tipi yok). Yenileme onay ister; eski etiket çalışmaz hale gelir.
 */
const QrNoktasiKarti = ({ nokta, onYenile }: Props) => {
    const dispatch = useDispatch();
    const depo = nokta.tur != 2;
    const etiketler = noktaEtiketleri(nokta);

    const yenileOnayi = (ambalaj: boolean) => {
        dispatch(storeEbbeModalCallback({
            title: ambalaj ? "Ambalaj QR'ını yenile" : depo ? "QR'ları yenile" : "QR'ı yenile",
            body: '',
            vurgu: {
                renk: 'kirmizi',
                baslik: 'Eski etiket çalışmaz',
                kalin: nokta.ad,
                metin: ambalaj
                    ? "noktasının yalnız Ambalaj QR'ı yenilenecek; asılı Ambalaj etiketi okutulamaz hale gelir."
                    : depo
                        ? "noktasının Lojistik ve Ambalaj QR'larının ikisi de yenilenecek; asılı iki etiket de okutulamaz hale gelir."
                        : "noktasının QR'ı yenilenecek; asılı etiket okutulamaz hale gelir.",
                soru: 'Devam edilsin mi?'
            },
            buttons: [
                { text: 'Vazgeç', btnClass: 'btn-light' },
                { text: 'Yenile', btnClass: 'btn-danger', onClick: () => onYenile(ambalaj) }
            ]
        }))
    }

    return (
        <KTCard className="ebbe-card mt-10">
            <KTCardBody>
                <h4 className="mb-10 text-black">{depo ? 'QR Kodları' : 'QR Kodu'}</h4>

                <div className="d-flex flex-wrap align-items-start gap-10">
                    <div className="d-flex flex-column align-items-center gap-3">
                        <QrEtiket
                            qrMetni={nokta.qrMetni ?? ''}
                            baslik={nokta.ad}
                            qrKodu={nokta.qrKodu}
                            renk={depo ? QR_RENKLERI.lojistik : undefined}
                            isTipi={depo ? 'Lojistik' : undefined}
                        />
                        {
                            depo && <div className="text-muted fs-8 text-center" style={{ maxWidth: 220 }}>Talebe yerleşir, siparişe düşer + puantaj</div>
                        }
                    </div>

                    {
                        depo && nokta.qrMetniAmbalaj && (
                            <div className="d-flex flex-column align-items-center gap-3">
                                <QrEtiket
                                    qrMetni={nokta.qrMetniAmbalaj}
                                    baslik={nokta.ad}
                                    qrKodu={nokta.qrKoduAmbalaj}
                                    renk={QR_RENKLERI.ambalaj}
                                    isTipi='Ambalaj'
                                />
                                <div className="text-muted fs-8 text-center" style={{ maxWidth: 220 }}>Yalnız puantaj</div>
                            </div>
                        )
                    }

                    <div className="d-flex flex-column gap-3">
                        <button type="button" className="btn btn-sm fw-bold btn-light-primary" onClick={() => qrYazdir(etiketler)} disabled={etiketler.length == 0}>
                            <i className="fa fa-print me-1" />
                            {etiketler.length > 1 ? "QR'ları Yazdır" : 'QR Yazdır'}
                        </button>

                        <button type="button" className="btn btn-sm fw-bold btn-light-danger" onClick={() => yenileOnayi(false)}>
                            <i className="fa fa-sync-alt me-1" />
                            {depo ? "QR'ları yenile" : "QR'ı yenile"}
                        </button>

                        {
                            depo && (
                                <button type="button" className="btn btn-sm fw-bold btn-light-warning" onClick={() => yenileOnayi(true)}>
                                    <i className="fa fa-sync-alt me-1" />
                                    Yalnız Ambalaj QR'ını yenile
                                </button>
                            )
                        }
                    </div>
                </div>

                <div className="text-muted fs-7 mt-5">
                    {
                        depo
                            ? "Depoya iki etiket asılır: personel Lojistik işinde mavi, ambalaj işinde turuncu çerçeveli QR'ı okutur; iş tipi telefonda sorulmaz, QR'dan gelir. Eski basılı etiket Lojistik olarak geçerlidir."
                            : "Etiketi yazdırıp ofise asın; personel mesai başı ve sonunda telefonuyla okutur. Ofis mesaisi yalnız puantaja girer."
                    }
                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default QrNoktasiKarti;
